import { IInventoryPage } from '../../inventory-page.interface';


export const GENERAL_DASHBOARD_PAGE: IInventoryPage = {
	'route': '/',
	'title': 'Dashboard',
	'uiReference': [
		'Overview',
		'Latest Release',
		'Loading latest releases',
		'No releases available',
		'New product updates will appear here.',
		'Latest releases are unavailable',
		'We could not load the latest updates. Please try again later.',
		'Loading designs',
		'Trend data is unavailable',
		'We could not load the design trends. Please try again later.',
		'No trend data available',
		'Design trends will appear here when data is available.',
		'Research',
		'Design Research, AI Research, KW Research. Check the latest best sellers and trends on Merch by Amazon! Insights like best seller rank, keywords and sales history. Get inspired by the most common and successful Print on Demand platform.',
		'Trademarks',
		'Trademarks. Stay safe with your listing. Check the relevant offices and nice classes for millions of trademarks in no time with Flying. Monitor your most relevant keywords and get email updated every week.',
		'Design Management',
		'Design, listing and trademark management. Manage all your data in the most advanced Edit section you have ever seen. Use various functions, lists and statistics for your advantage. Keep everything organized with access from everywhere.',
		'Upload Automation',
		'Upload automation. Upload to the most relevant Print on Demand sites automatically in no time. You have full control with the local Flying Upload. Transfer data between your PC and Flying. With the upload manager, you always know where you already have uploaded your design.',
		'Available channels'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/shared-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/home/home.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/home/home.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/home/home.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/home/card/card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/home/card/card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html'
	],
	'aliases': [
		'Home'
	]
};
